import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ── Error #31 interceptor ────────────────────────────────────────────────────
// Monkey-patch console.error to catch React's "Objects are not valid as a React child"
// and log which component is involved
const origConsoleError = console.error;
console.error = (...args) => {
  origConsoleError.apply(console, args);
  const msg = args.map(a => (typeof a === 'string' ? a : '')).join(' ');
  if (msg.includes('not valid as a React child') || msg.includes('object with keys') || msg.includes('invariant=31')) {
    // Dump the full error details
    origConsoleError('=== REACT ERROR #31 DETAILS ===');
    args.forEach((arg, i) => {
      if (arg instanceof Error) {
        origConsoleError(`  arg[${i}] Error:`, arg.message);
        origConsoleError(`  arg[${i}] Stack:`, arg.stack);
      } else if (typeof arg === 'object' && arg !== null) {
        try {
          origConsoleError(`  arg[${i}] Object:`, JSON.stringify(arg).substring(0, 500));
        } catch (e) {
          origConsoleError(`  arg[${i}] Object (unserializable):`, Object.keys(arg));
        }
      }
    });
    origConsoleError('=== END ERROR #31 DETAILS ===');
  }
};

window.onerror = (msg, source, lineno, colno, error) => {
  if (String(msg).includes('invariant=31') || String(msg).includes('object with keys')) {
    origConsoleError('=== WINDOW.ONERROR #31 ===');
    origConsoleError('  Message:', msg);
    origConsoleError('  Source:', source, 'Line:', lineno, 'Col:', colno);
    if (error && error.stack) origConsoleError('  Stack:', error.stack);
    origConsoleError('=== END ===');
  }
};

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  if (reason && String(reason.message || reason).includes('invariant=31')) {
    origConsoleError('=== UNHANDLED REJECTION #31 ===', reason);
  }
});
// ── End interceptor ──────────────────────────────────────────────────────────

// ── BFCache defeat ───────────────────────────────────────────────────────────
// Browsers (Safari, Chrome, Firefox) cache fully-hydrated pages in their
// back/forward cache. When the user hits Back, the page is restored from this
// snapshot — including the JS bundle in memory at the time of navigation away.
// Two problems with that for ZignaGenix:
//   1. After a deploy, BFCache resurrects the old bundle (visible to users as
//      "the new screen flashed and reverted to the old one when I hit Back").
//   2. Worse — BFCache can restore an authenticated UI after the 15-min HIPAA
//      idle timeout has already fired server-side, masking a stale session.
// Force a reload whenever the page is restored from BFCache. This costs one
// extra network round-trip on Back navigation but guarantees a fresh bundle
// and a fresh server-side session check every time.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});
// ── End BFCache defeat ───────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
